module.exports = __webpack_public_path__ + "img/logo (2).b48972fa.svg";